<template>
<tr>
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
        <span>
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon color="grey darken-2" size="13" v-on="on" style="vertical-align: text-bottom">help_outline</v-icon>
                </template>
                <span>
                    <div class="" style="width: max-content">
                        <span class="pl-1">{{ $t('sheet.sheet_components.min_max_inventory.tooltip.restrictions_min_max') }}</span>
                    </div>
                </span>
            </v-tooltip>
        </span>
        {{ $t('sheet.sheet_components.min_max_inventory.title') }}
    </th>
    <td class="sheet-cell text-center" v-for="(day, index) in prices" :key="index">
        <v-progress-circular v-if="loading_date_min == day.date" size="12" width="2" indeterminate style="width: 50%" />
        <input v-else v-model.lazy="day.min_inventory" class="sheet-input-left" @change="save_min(day)" />

        <v-progress-circular v-if="loading_date_max == day.date" size="12" width="2" indeterminate style="width: 50%" />
        <input v-else v-model.lazy="day.max_inventory" class="sheet-input-right" @change="save_max(day)" />
    </td>
</tr>
</template>
<script>
import {
    mapActions
} from 'vuex';
export default {
    props: {
        prices: Object,
        backup_sheet: [Object, Array],
        params: Object
    },
    data() {
        return {
            loading_date_min: null,
            loading_date_max: null
        }
    },
    methods: {
        ...mapActions('alert', ['success', 'error']),

        save_min(day) {
            this.loading_date_min = day.date;
            let pricing = {};
            pricing[day.room_type_id] = {};
            pricing[day.room_type_id][day.rate_plan_id] = {};
            pricing[day.room_type_id][day.rate_plan_id][day.date] = {
                min_inventory: day.min_inventory
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.pricing = pricing;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].max_booking_date = day.min_inventory;
                })
                .catch(error => {
                    this.prices[day.date].min_inventory = this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].min_inventory;
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date_min = null;
                });
        },

        save_max(day) {
            this.loading_date_max = day.date;
            let pricing = {};
            pricing[day.room_type_id] = {};
            pricing[day.room_type_id][day.rate_plan_id] = {};
            pricing[day.room_type_id][day.rate_plan_id][day.date] = {
                max_inventory: day.max_inventory
            };
            let query_params = {};

            query_params.hotel_id = this.params.hotel_id;
            query_params.date_start = this.params.date_start;
            query_params.date_stop = this.params.date_stop;
            query_params.pricing = pricing;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/sheet';


            this.$axios.post(endpoint, query_params)
                .then(response => {
                    this.success(this.$t('sheet.message_update'));
                    this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].max_inventory = day.max_inventory;
                })
                .catch(error => {
                    this.prices[day.date].max_inventory = this.backup_sheet.pricing[day.room_type_id][day.rate_plan_id][day.date].max_inventory;
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {
                    this.loading_date_max = null;
                });
        }

    }
}
</script>
